"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _index = require("../../Spinner/index.js");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Loading = function Loading(_ref) {
  var height = _ref.height,
      motion = _ref.motion,
      children = _ref.children,
      testId = _ref.testId;
  return _react2.default.createElement("div", {
    "data-testid": testId,
    className: "flex justify-center items-center",
    style: _extends({
      height: height
    }, motion)
  }, children || _react2.default.createElement(_index2.default, null));
};

exports.default = Loading;